<div class="form-row">
  <div class="form-group col-md-4">
    <label for="inputEmail4">Name</label>
    <input type="text" name='name' [(ngModel)]='this.userGroup.name' [class.is-invalid]='!this.userGroup.name' class="form-control" id="inputEmail4">
  </div>
</div>

<div class='form-row'>
  <div class='form-group col-md-12'>
    <label>Permissions</label>
    <ng-select
          [items]="this.permissions"
          bindLabel="name"
          [multiple]="true"
          [closeOnSelect]="false"
          [compareWith]="compareById"
          placeholder="Select permissions"
          [(ngModel)]="this.userGroupPermissions.permissions">
          <ng-template ng-header-tmp>
            <button type="button" class="btn btn-sm btn-link" (click)="this.userGroupPermissions.permissions = this.permissions.slice()">Select All</button>
            <button type="button" class="btn btn-sm btn-link" (click)="this.userGroupPermissions.permissions = []">UnSelect All</button>
          </ng-template>
        </ng-select>
  </div>
</div>
